import React from "react";
import { NavLink } from "react-router-dom";
import StaffProfileCard from "../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../util/app";

const RotaDetails = ({ location }) => {
    const { item } = location.state;
    return (
        <>
            <NavLink
                className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success"
                to={{
                    pathname: `/home/rota/rotalist`
                }}
            >
                <i className="material-icons">keyboard_arrow_left</i> Back
            </NavLink>
            <div className="row mt-5">
                <div className="col-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="col-4 bg-primary pl-5">
                                <h5>Detail</h5>
                            </div>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                            <strong>Duty Period</strong>
                                        </td>
                                        <td>{item.period.name}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                            <strong>Start Date & Time</strong>
                                        </td>
                                        <td>{cleanDate(item.date, false, false)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                            <strong>End Date & Time</strong>
                                        </td>
                                        <td>{cleanDate(item.end_date, false, false)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                            <strong>Created By</strong>
                                        </td>
                                        <td>
                                            <StaffProfileCard item={item.author} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="col-4 bg-primary pl-5">
                        <h5>Staff On Duty | {item.assignee.length}</h5>
                    </div>
                    <div className="row justify-content-start">
                        {item.assignee.map(x => {
                            return (
                                <div className="col-md-4  col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="profile-userpic">
                                                <center>
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${x.staff.image || `https://dummyimage.com/100x100&text=${x.staff.surname}`})`,
                                                            width: "80px",
                                                            height: "80px"
                                                        }}
                                                        className="img-container margin-top-20 user-img-circle"
                                                    ></div>
                                                </center>
                                            </div>
                                        </div>
                                        <div className="card-body text-center" style={{ minHeight: "100px" }}>
                                            <StaffProfileCard item={x.staff} />
                                        </div>
                                        <div className="card-footer text-center">
                                            {!item.assignee.attended && <span className="badge badge-pill badge-danger fade-in">Unattended</span>}
                                            {item.assignee.attended && <span className="badge badge-pill badge-success fade-in">Attended</span>}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RotaDetails;
